import { render, staticRenderFns } from "./parcel-book-footer.vue?vue&type=template&id=37dc9879"
import script from "./parcel-book-footer.vue?vue&type=script&lang=js"
export * from "./parcel-book-footer.vue?vue&type=script&lang=js"
import style0 from "./parcel-book-footer.vue?vue&type=style&index=0&id=37dc9879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports